import React from 'react';
import UIKitMenuItem from './MenuItem';
import UIKitDropDownShell, { DropDownContext, DropDownStyleProps } from './DropDownShell';

import { ThemeColor } from '../theme';
import { OptionValue } from '../../services/types/Misc';

export interface UIKitDropDownProps {
  elements: OptionValue[];
  value: number | null;
  onChange: (value: number) => void;
  label?: string;
  htmlId?: string;
  disabled?: boolean;
  leftIcon?: React.ReactNode;
  dropDownStyles?: DropDownStyleProps;
  color?: ThemeColor;
  className?: string;
  error?: boolean;
  helperText?: string;
  style?: React.CSSProperties;
  fullWidth?: boolean;
  placeholder?: string;
}

const UIKitDropDown: React.FC<UIKitDropDownProps> = ({
  elements,
  value,
  onChange,
  label,
  htmlId,
  disabled,
  leftIcon,
  dropDownStyles,
  color,
  className,
  error,
  helperText,
  style,
  fullWidth,
  placeholder,
}) => {
  // texto a mostrar en el trigger
  const selected = elements.find((x) => x.id === value);
  const text = selected ? selected.text : placeholder || ' ';

  // defaults
  const isDisabled = !!disabled;
  const themeColor: ThemeColor = error ? 'error' : color || 'primary';

  return (
    <UIKitDropDownShell
      text={text}
      label={label}
      htmlId={htmlId}
      leftIcon={leftIcon}
      color={themeColor}
      disabled={isDisabled}
      dropDownStyles={dropDownStyles}
      className={className}
      error={error}
      helperText={helperText}
      style={style}
      fullWidth={fullWidth}
    >
      <DropDownContext.Consumer>
        {({ onClose }) =>
          elements.map((opt) => (
            <UIKitMenuItem
              key={opt.id}
              text={opt.text}
              selected={opt.id === value}
              disabled={!!opt.disabled}
              onClick={() => {
                onChange(opt.id);
                onClose();
              }}
            />
          ))
        }
      </DropDownContext.Consumer>
    </UIKitDropDownShell>
  );
};

export default UIKitDropDown;
